import React from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { sendEditToApi } from '../actions/edit'
import { sentText } from '../actions/text'
import './submit-text.css'

export class EditText extends React.Component {
	constructor(props){
		super(props)
		this.body = ''
		this.comment =''
	}

	submit(e, body, comment) {
		e.preventDefault()

		const text = this.props.location.state.text

		const textObj = {
			textId: text._id,
			title: text.title,
			body: this.body.value,
			authorId: text.authorId,
			authorName: text.authorName,
			editorName: this.props.currentUser.username,
			editorId: this.props.uid,
			editorComment: this.comment.value
		}
		this.props.dispatch(sendEditToApi(textObj))
		this.props.dispatch(sentText(true))
	}

	render() {
		if (!this.props.loggedIn) {
	        return <Redirect to="/" />;
	    }
	    if (this.props.sentText) {
        	return <Redirect to="/" />
        }

	    const text = this.props.location.state.text

	    return(
				<div className='row'>
					<h2>Edit {text.authorName}'s post:</h2>
					<div className='view-form col-8'>
						<h2>{text.title}</h2>
						<textarea 
							defaultValue={text.body} 
							className='form col-12' 
							ref={input => this.body = input}
						/>
					</div>
					<div className='editor-comment col-4'>
						<textarea 
							placeholder='Leave a comment explaining your thoughts'
							name='comment' 
							ref={input => this.comment = input}
						/>
						<button className='submit-edit' onClick={e => this.submit(e, this.body.value, this.comment.value)}>Submit</button>
					</div>
				</div>
		)
	}
}

const mapStateToProps = state => ({
	sentText: state.text.sentText,
    currentUser: state.auth.currentUser,
    hasAuthToken: state.auth.authToken !== null,
    loggedIn: state.auth.currentUser !== null,
    uid: state.auth.uid
})

export default connect(mapStateToProps)(EditText)


// WEBPACK FOOTER //
// ./src/components/edit-text.js